import React from 'react';
import { Redirect } from "react-router-dom";
import { APPID, APPVERSION, INSTANCE_TOKEN, QUIZ_INSTANCE } from '../common/globals';
import { BASE_AXIOS } from "../config";

export const apiEditDeck = async (data) => {
    let form = new FormData();
    
    form.append("deckID", data.deckID);
    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.deckPriority !== 'undefined') {
        form.append("sortOrder", data.deckPriority);
    }

    if (typeof data.deckName !== 'undefined') {
        form.append("deckName", data.deckName);
    }

    if (typeof data.decksummary !== 'undefined') {
        form.append("decksummary", data.decksummary);
    }

    if (typeof data.gamemode !== 'undefined') {
        form.append("gamemode", data.gamemode);
    }

    if (typeof data.isActive !== 'undefined') {
        form.append("isActive", data.isActive);
    }

    if (typeof data.isPublic !== 'undefined') {
        form.append("isPublic", data.isPublic);
    }

    if (typeof data.isSpaced !== 'undefined') {
        form.append("isSpaced", data.isSpaced);
    }

    if (typeof data.isHome !== 'undefined') {
        form.append("isHome", data.isHome);
    }

    if (typeof data.flashCards !== 'undefined') {
        form.append("flashCards", data.flashCards);
    }

    if (data.isWrong) {
        form.append("isWrong", data.isWrong ? 1 : 0);
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 
    
    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "editDeck"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const apiCopyDeck = async (data) => {
    let form = new FormData();
    let obj = {
        mcid: data.mcid,
        key: data.key,
        deckID: data.deckID,
    }
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("deckID", data.deckID);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "copyDeck"
            },
            data: form
        });
        
        let results;
        if (Array.isArray(response.data)) {
            results = response.data;
        } else { results = []; }

        return results;
    } catch (error) {
        throw error;
    }
}

export const apiSubscribeDeck = async (data) => {
    let form = new FormData();
    let obj = {
        mcid: data.mcid,
        key: data.key,
        deckID: data.deckID,
    }
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("deckID", data.deckID);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }


    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "subscribeDeck"
            },
            data: form
        });
        
        let results;
        if (Array.isArray(response.data)) {
            results = response.data;
        } else { results = []; }

        return results;
    } catch (error) {
        throw error;
    }
}

export const apiAddNote = async (data) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }

    let obj = {
        mcid: data.mcid,
        key: data.key
    };

    if (typeof data.comment !== 'undefined') {
        form.append("comment", data.comment);
        obj.comment = data.comment;
    }

    if (typeof data.deckID !== 'undefined') {
        form.append("deckID", data.deckID);
        obj.deckID = data.deckID;
    }

    if (typeof data.yearvar !== 'undefined') {
        form.append("yearvar", data.yearvar);
        obj.yearvar = data.yearvar;
    }

    if (typeof data.questionID !== 'undefined') {
        form.append("questionID", data.questionID);
        obj.questionID = data.questionID;
    }

    if (typeof data.state !== 'undefined') {
        form.append("state", data.state);
        obj.state = data.state;
    }

    if (typeof data.noteID !== 'undefined') {
        form.append("noteID", data.noteID);
        obj.noteID = data.noteID;
    }

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "noteApi"
            },
            data: form
        });
        
        let results = [];
        if (Array.isArray(response.data)) {
            results = response.data;
        } else if (typeof response.data === 'object') { 
            results.push(response.data); 
        }

        return results;
    } catch (error) {
        throw error;
    }
}

export const apiSubmitQuiz = async (data) => {
    let form = new FormData();
    
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("detail", QUIZ_INSTANCE());
    form.append(`detailvar`, `quizinstance`);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);
    form.append(`questionidstr`, data.questionidstr);
    form.append(`grade`, data.grade);
    form.append(`score`, data.score);
    form.append(`totalquestions`, data.totalquestions);

    if (typeof data.gameMode !== 'undefined') {
        form.append("gamemode", data.gameMode);
    } else if (typeof data.gamemode !== 'undefined') {
        form.append("gamemode", data.gamemode);
    }

    if (typeof data.deckID !== 'undefined') {
        form.append("deckid", data.deckID);
    } else if (typeof data.deckid !== 'undefined') {
        form.append("deckid", data.deckid);
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
    }    

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "saveQuizData"
            },
            data: form
        });
        
        return response;
    } catch (error) {
        throw error;
    }
}

export const apiResetDeck = async (data) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.deckID !== 'undefined') {
        form.append("deckID", data.deckID);
    }
    
    if (typeof data.yearvar !== 'undefined') {
        form.append("yearvar", data.yearvar); 
    }

    if (typeof data.gameMode !== 'undefined') {
        form.append("gamemode", data.gameMode);
    } else if (typeof data.gamemode !== 'undefined') {
        form.append("gamemode", data.gamemode);
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }    

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "resetDeck"
            },
            data: form
        });
        
        let results;
        if (Array.isArray(response.data)) {
            results = response.data[0].decks;
        } else { results = []; }

        return results;
    } catch (error) {
        throw error;
    }
}

export const apiShareDeck = async (data) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("shareWith", data.shareWith);
    if (typeof data.deckID !== 'undefined') { form.append("deckID", data.deckID); }
    if (typeof data.yearvar !== 'undefined') { form.append("yearvar", data.yearvar); } 

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "shareDeck"
            },
            data: form
        });
        
        let results;

        if (Array.isArray(response.data)) {
            results = response.data;
        } else { results = []; }

        return results;
    } catch (error) {
        throw error;
    }
}

export const apiEmailResults = async (data) => {
    let form = new FormData();
    let share = data.shareWith;
    share = share.replace(/\s/g, ';')
    share = share.replace(/,/g, ';')
    share = share.replace(/;;/g, ';')

    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("sendTo", share);
    form.append("gameMode", data.gameMode);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    }

    let obj = {
        mcid: data.mcid,
        key: data.key,
        share: share,
        deckID: null,
        yearvar: null
    }

    if (typeof data.deckID !== 'undefined') { form.append("deckID", data.deckID); obj.deckID = data.deckID}
    if (typeof data.yearvar !== 'undefined') { form.append("yearvar", data.yearvar);  obj.yearvar = data.yearvar}

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "emailResults"
            },
            data: form
        });
        
        let results;
        if (Array.isArray(response.data)) {
            results = response.data;
        } else { results = []; }

        return results;
    } catch (error) {
        throw error;
    }
}

export const apiSendMessage = async (data) => {
    let form = new FormData();
    let share = data.shareWith;
    share = share.replace(/\s/g, ';')
    share = share.replace(/,/g, ';')
    share = share.replace(/;;/g, ';')

    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("sendTo", share);
    form.append("message", data.message);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);

    if (typeof data.deckID !== 'undefined') {
        form.append("deckID", data.deckID ? data.deckID : null);
    }

    if (typeof data.yearvar !== 'undefined') {
        form.append("yearvar", data.yearvar ? data.yearvar : null);
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
    }
    
    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "emailResults"
            },
            data: form
        });
        
        let results;
        if (Array.isArray(response.data)) {
            results = response.data;
        } else { results = []; }

        return results;
    } catch (error) {
        throw error;
    }
}